/**
 * Considerations interface for filtering vehicle offers
 */
export interface Considerations {
  newStart: boolean;
  newEnd: boolean;
  whereAt: boolean;
  remainingCabotages: boolean;
  dimensions: boolean;
  body: boolean;
  type: boolean;
  equipment: boolean;
  lists: boolean;
}

/**
 * Default considerations with all filters enabled
 */
export const defaultConsiderations: Considerations = {
  newStart: true,
  newEnd: true,
  whereAt: true,
  remainingCabotages: true,
  dimensions: true,
  body: true,
  type: true,
  equipment: true,
  lists: true,
};
